import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=0617e8ae"
import script from "./brandList.vue?vue&type=script&lang=js"
export * from "./brandList.vue?vue&type=script&lang=js"
import style0 from "./brandList.vue?vue&type=style&index=0&id=0617e8ae&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0617e8ae')) {
      api.createRecord('0617e8ae', component.options)
    } else {
      api.reload('0617e8ae', component.options)
    }
    module.hot.accept("./brandList.vue?vue&type=template&id=0617e8ae", function () {
      api.rerender('0617e8ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/brandlist/brandList.vue"
export default component.exports